import React from "react";
import style from "styled-components";
import PropTypes from "prop-types";
import Title from "../Title";

const Container = style.div`
      display:flex;
      flex-direction:row;
      justify-content:center;
      margin:3.0rem;
      border:3px solid red;
`;

export default function Empty({ children }) {
    return (
        <Container>
            <Title>{children}</Title>
        </Container>
    );
}


Empty.propTypes = {
    children: PropTypes.string
};